let fullheight = {
    initHeight: function () {
        setTimeout(function () {
            var importantNotice = document.querySelector('.important-notice__visible');
                   var fullheightpage = document.querySelectorAll('.count-fullheight');
                const header = document.querySelector('.site-header');
                const tabContent = document.querySelector('.tab-content');
                if (importantNotice !== null && importantNotice.offsetHeight > 0 && fullheightpage !== null) {
              var headerHeight = header.offsetHeight;
                    const calculateHeight = () => {
                        const fullheightElements = tabContent ? tabContent.querySelectorAll('.content-fullheight') : null;

                        const noticeHeight = importantNotice.offsetHeight || 0;
                        const headerHeight = header.offsetHeight || 0;
                        const windowHeight = window.innerHeight;
                        const newHeight = windowHeight - noticeHeight - headerHeight;
                        if (fullheightpage !== null) {
                            fullheightpage.forEach(el => {
                                el.style.height = `${newHeight}px`;
                                el.classList.add('heightcounted');
                            });
                        } if (fullheightElements !== null) {
                            fullheightElements.forEach(el => {

                                el.style.height = `${newHeight}px`;
                                el.classList.add('heightcounted');
                            });
                        }
                    };
                    setTimeout(() => {
                        var maplink = document.querySelector('.maplink');
                        if (maplink !== null) {
                            maplink.addEventListener('click', function () {
                                if (importantNotice !== null) {
                                    importantNotice.classList.add('viewmap');
                                }
                            });
                        } else {
                            calculateHeight();
                            if (tabContent) {
                                const tabs = document.querySelectorAll('.tab');
                                tabs.forEach(tab => {
                                    tab.addEventListener('click', function () {
                                        setTimeout(() => {
                                            calculateHeight();
                                        }, 100);
                                    });
                                });
                            }
                        }
                    }, 500);


                    importantNotice.querySelector('.icon-close').onclick = function () {
                        var heightcounted = document.querySelectorAll('.heightcounted');
                        heightcounted.forEach(el => {
                            el.style.removeProperty("height");
                            el.classList.remove('heightcounted');
                        });
                    }
                }
        }, 100);
    },
     removeViewmap: function () {
         setTimeout(() => {
             var importantNotice = document.querySelector('.important-notice__visible.viewmap');
             if (importantNotice !== null) {
                 importantNotice.classList.remove('viewmap');
             }
         }, 100);
    }
};

export { fullheight };
